import { Link } from 'react-router-dom';
import cn from 'classnames';
import { AppImage } from '@/shared/ui/AppImage';
import { ImageType } from '@/shared/types/common';

interface UserAvatarProps {
  avatar: ImageType;
  userName: string;
  href?: string;
  className?: string;
  size?: number;
  textColor?: 'black' | 'white';
}

export const UserAvatar = ({
  userName,
  avatar,
  href,
  className,
  size = 6,
  textColor = 'black',
}: UserAvatarProps) => {
  const nameSizeClass =
    size <= 7 ? 'text-sm' : size <= 10 ? 'text-[16px]' : 'text-[18px]';
  const nameColorClass = textColor === 'white' ? 'text-white' : 'text-black-DEFAULT';

  const content = (
    <>
      <AppImage
        src={avatar}
        alt={`${userName} avatar`}
        className={`w-${size} h-${size} object-cover rounded-full`}
      />
      <p className={cn(nameSizeClass, nameColorClass)}>{userName}</p>
    </>
  );

  const rowClass = 'flex items-center gap-x-2';

  return href ? (
    <Link className={cn(rowClass, className)} to={href} aria-label={`View profile of ${userName}`}>
      {content}
    </Link>
  ) : (
    <div className={cn(rowClass, className)}>{content}</div>
  );
};
